import Pattern from '../ASSETS/MemoryTwistPattern.svg';
import PatternApple from '../ASSETS/MemoryTwistPatternApple.svg';
import { apple } from '../../HOME/utils';

export const Background = `radial-gradient(transparent, black 100%), url(${apple ? PatternApple : Pattern})`;
